var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGm = function SvgGm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gm_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M0-48h640v480H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    clipPath: "url(#gm_svg__a)",
    transform: "translate(0 48)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M0-128h640V85.3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 85.3h640V121H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009",
    d: "M0 120.9h640V263H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 263.1h640v35.6H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090",
    d: "M0 298.7h640V512H0z"
  }))));
};
export default SvgGm;